"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fade = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_cool_inview_1 = require("react-cool-inview");
var Fade = function (_a) {
    var sx = _a.sx, props = __rest(_a, ["sx"]);
    var _b = (0, react_cool_inview_1.useInView)({
        unobserveOnEnter: true,
    }), inView = _b.inView, observe = _b.observe;
    return props.children ? ((0, jsx_runtime_1.jsx)(material_1.Fade, __assign({}, props, { in: inView || props.in, ref: observe, timeout: props.timeout || 600, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: sx, children: props.children }) }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
};
exports.Fade = Fade;
